module.exports = __webpack_public_path__ + "static/slider2_mobile-6d1d225481bfa3d79ffac63d5f06d6d5.png";